import React from "react";
import { Panel } from "./FrequencyChart";

export const OverdueList = ({ overdue }) => (
  <Panel title="Most Overdue Numbers" testid="overdue-list">
    <div className="space-y-2">
      {overdue.map((o) => (
        <div
          key={o.number}
          data-testid={`overdue-${o.number}`}
          className="flex items-center justify-between gap-3 rounded-lg bg-zinc-950/50 border border-zinc-800 px-3 py-2"
        >
          <div className="w-9 h-9 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center font-mono font-bold text-sm text-[#FF2D55]">
            {String(o.number).padStart(2, "0")}
          </div>
          <div className="flex-1 h-2 rounded-full bg-zinc-800 overflow-hidden">
            <div
              className="h-full rounded-full"
              style={{
                width: `${Math.min(100, (o.gap / (overdue[0].gap || 1)) * 100)}%`,
                backgroundColor: "#FF2D55",
              }}
            />
          </div>
          <div className="font-mono text-xs text-zinc-400 w-24 text-right">
            {o.gap} draws ago
          </div>
        </div>
      ))}
    </div>
  </Panel>
);

export const PairsList = ({ pairs }) => (
  <Panel title="Frequent Pairs" testid="pairs-list">
    <div className="grid grid-cols-2 gap-2">
      {pairs.map((p) => (
        <div
          key={`${p.pair[0]}-${p.pair[1]}`}
          data-testid={`pair-${p.pair[0]}-${p.pair[1]}`}
          className="flex items-center justify-between rounded-lg bg-zinc-950/50 border border-zinc-800 px-3 py-2"
        >
          <div className="flex items-center gap-1.5 font-mono font-bold text-sm text-zinc-100">
            <span className="w-7 h-7 rounded-full bg-zinc-800 flex items-center justify-center text-xs">
              {p.pair[0]}
            </span>
            <span className="text-zinc-600 text-xs">+</span>
            <span className="w-7 h-7 rounded-full bg-zinc-800 flex items-center justify-center text-xs">
              {p.pair[1]}
            </span>
          </div>
          <span className="font-mono text-xs text-zinc-400">{p.count}×</span>
        </div>
      ))}
    </div>
  </Panel>
);
